import { BusEvent } from '@web/common';

export class AdminProductChangedBusEvent extends BusEvent {}
